import { TEXT_INPUT_ROLE } from '@wix/wix-data-client-common-standalone'

import { type TextInputData } from '../types'
import {
  assertNonNullable,
  assertTextInputData,
  setConnectionConfigPropertyField,
} from '../utils'
import { addComponentForField } from './addComponentForField'
import { type FieldComponentAdder } from './types'

export const createTextInputAdder =
  (templateVeloId: string): FieldComponentAdder =>
  ({
    fieldKey,
    fieldName,
    page,
    templateComponentByVeloId,
    templateControllerConnectionsByVeloId,
  }) =>
    addComponentForField({
      page,
      templateComponentByVeloId,
      templateControllerConnectionsByVeloId,
      templateVeloId,
      componentAdjustments: {
        modifyComponent: component => {
          assertNonNullable(component.data)
          assertTextInputData(component.data)
          const data: TextInputData = { ...component.data, label: fieldName }
          return { ...component, data }
        },
        connectionConfigModifierByRole: {
          [TEXT_INPUT_ROLE]: config =>
            setConnectionConfigPropertyField({
              config,
              propertyName: 'value',
              fieldKey,
            }),
        },
        veloId: `${fieldKey}Field`,
      },
    })
